import type { ImportSourceConfig, WatchBrand } from '../types';

/**
 * True when the brand has a Square Online import source configured. Drives the
 * brand listing's Square Online pill and row tint — the counterpart of
 * `brandHasShopifySource` in firebase.ts.
 *
 * Unlike Shopify there is no legacy brand-doc field to fall back to: a Square
 * Online source only ever lives in the brand's import-sources doc, so a null
 * map (still loading, or failed) or a brand without a sources doc reads false.
 */
export function brandHasSquareOnlineSource(
  brand: Pick<WatchBrand, 'id'>,
  sourcesByBrand: Map<string, ImportSourceConfig[]> | null,
): boolean {
  return Boolean(
    sourcesByBrand?.get(brand.id)?.some((s) => s.kind === 'square-online'),
  );
}

/**
 * True when the brand has a WooCommerce import source configured — the
 * WooCommerce pill and row tint. Same rules as Square Online: the sources doc
 * is the only signal, so a null map or a brand without a doc reads false.
 */
export function brandHasWooCommerceSource(
  brand: Pick<WatchBrand, 'id'>,
  sourcesByBrand: Map<string, ImportSourceConfig[]> | null,
): boolean {
  return Boolean(
    sourcesByBrand?.get(brand.id)?.some((s) => s.kind === 'woocommerce'),
  );
}
